import React, { Fragment, useState } from 'react';
import { Avatar, Typography, Divider, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import TelegramIcon from '@mui/icons-material/Telegram';
import moment from 'moment';
import { EditButton } from '../../../_Components';
import Utils from '../utils';
import EditOperatorModal from './EditOperatorModal';

const { places, operatorsTypes, departments } = Utils.options();

const OperatorProfile = ({ data, edit, classes, onDataUpdate }) => {
    const [editModalOpen, setEditModalOpen] = useState(false);

    const handleEditClick = () => {
        setEditModalOpen(true);
    };

    const handleCloseModal = () => {
        setEditModalOpen(false);
    };

    const handleSave = () => {
        if (onDataUpdate) {
            onDataUpdate();
        }
    };
    if (!data) return null;

    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        }
        return name[0]?.toUpperCase() || '';
    };

    const getFullName = () => {
        if (data.fullname) return data.fullname;
        if (data.name) {
            const parts = [
                data.name.last,
                data.name.first,
                data.name.second
            ].filter(Boolean);
            return parts.join(' ') || data.login || '';
        }
        return data.login || '';
    };

    const fullName = getFullName();

    return (
        <Fragment>
            <div className={classes.profileContainer}>
                <Avatar 
                    className={classes.avatar}
                    src={data.photo || data.avatar}
                    alt={fullName}
                >
                    {!data.photo && !data.avatar && getInitials(fullName)}
                </Avatar>
                <Typography className={classes.fullName}>
                    {fullName}
                </Typography>
               
                <div className={classes.statusIndicator} style={{ color: data.status === 'Active' ? '#4caf50' : '#ec716a' }}>
                    <span>{data.status === 'Active' ? 'Активен' : 'Уволен'}</span>
                </div>
                <div className={classes.contactButtons}>
                    <Button 
                        variant="contained" 
                        color="primary"
                        disabled={!data.contact?.telegram}
                        className={classes.contactButton}
                        href={`tg://resolve?domain=${data.contact?.telegram}`}
                        startIcon={<TelegramIcon />}
                    >
                        Написать
                    </Button>
                    <EditButton handleEditClick={handleEditClick} />
                </div>
            </div>
            <div className={classes.contactInfo}>
                <Typography style={{ fontSize: '13px', color: '#0a2b61', marginBottom: 8, fontWeight: 600 }}>
                    Основные данные
                </Typography>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Тип:</span>
                    <span className={classes.contactValue}>
                        {operatorsTypes.find(t => t.id === data.type)?.name || data.type}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Логин:</span>
                    <span className={classes.contactValue}>
                        {data.login || '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Отдел:</span>
                    <span className={classes.contactValue}>
                        {departments.find(d => d.id === data.department)?.name || data.department}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Отдел:</span>
                    <span className={classes.contactValue}>
                        {places.find(p => p.id === data.place)?.name || data.place}
                    </span>
                </div>
                {/* <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Стаж работы:</span>
                    <span className={classes.contactValue}>
                        {calculateTenure(data.contract[0]?.start) || '-'}
                    </span>
                </div> */}
            </div>
            <Divider/>
            
            <div className={classes.contactInfo}>
                <Typography style={{ fontSize: '13px', color: '#0a2b61', marginBottom: 8, fontWeight: 600 }}>
                    Контактные данные
                </Typography>
                <div className={classes.contactItem}>
                    <PhoneIcon style={{ fontSize: 18, color: '#666' }} />
                    <span className={classes.contactLabel}>Мобильный:</span>
                    <span className={classes.contactValue}>
                        {data.contact?.phone?.mobile || '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <PhoneIcon style={{ fontSize: 18, color: '#666' }} />
                    <span className={classes.contactLabel}>Другой:</span>
                    <span className={classes.contactValue}>
                        {data.contact?.phone?.mobile2 || '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <TelegramIcon style={{ fontSize: 18, color: '#666' }} />
                    <span className={classes.contactLabel}>Telegram:</span>
                    <span className={classes.contactValue}>
                        {data.contact?.telegram || '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <TelegramIcon style={{ fontSize: 18, color: '#666' }} />
                    <span className={classes.contactLabel}>Mini App:</span>
                    <span className={classes.contactValue}>
                        {data.telegramId || data.contact?.telegramId ? 'Привязан' : 'Не привязан'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <EmailIcon style={{ fontSize: 18, color: '#666' }} />
                    <span className={classes.contactLabel}>email:</span>
                    <span className={classes.contactValue}>
                        {data.contact?.email || '-'}
                    </span>
                </div>
            </div>

            <Divider/>

            <div className={classes.contactInfo}>
                <Typography style={{ fontSize: '13px', color: '#0a2b61', marginBottom: 8, fontWeight: 600 }}>
                    Адрес регистрации
                </Typography>
                <span className={classes.contactValue}>
                        {data.contact?.address?.state ? `${data.contact?.address?.state} обл., ` : ''}
                        {data.contact?.address?.district ? `${data.contact?.address?.district} р-н, ` : ''}
                        {data.contact?.address?.city ? `${data.contact?.address?.city}, ` : ''}
                        {data.contact?.address?.street ? `${data.contact?.address?.street}, ` : ''}
                        {data.contact?.address?.house ? `${data.contact?.address?.house}, ` : ''}
                        {data.contact?.address?.block ? `${data.contact?.address?.block}, ` : ''}
                        {data.contact?.address?.flat ? `${data.contact?.address?.flat}` : ''}
                    </span>
            </div>

            <Divider/>

            <div className={classes.contactInfo}>
                <Typography style={{ fontSize: '13px', color: '#0a2b61', marginBottom: 8, fontWeight: 600 }}>
                   Паспортные данные
                </Typography>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Дата рождения:</span>
                    <span className={classes.contactValue}>
                        {data?.passport?.birthday ? moment(data?.passport?.birthday).format('DD.MM.YYYY') : '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Личный номер:</span>
                    <span className={classes.contactValue}>
                        {data?.passport?.personal_number || '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Номер паспорта:</span>
                    <span className={classes.contactValue}>
                        {data?.passport?.number || '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Дата выдачи:</span>
                    <span className={classes.contactValue}>
                        {data?.passport?.date_issue ? moment(data?.passport?.date_issue).format('DD.MM.YYYY') : '-'}
                    </span>
                </div>
                <div className={classes.contactItem}>
                    <span className={classes.contactLabel}>Орган выдачи:</span>
                    <span className={classes.contactValue}>
                        {data?.passport?.issue || '-'}
                    </span>
                </div>
            </div>
            <EditOperatorModal
                open={editModalOpen}
                onClose={handleCloseModal}
                operatorData={data}
                onSave={handleSave}
            />
        </Fragment>
    );
};

export default OperatorProfile;

